import { useEffect, useState } from "react";
import {
  Button,
  Image,
  Typography,
  Row,
  Col,
  Input,
  Popconfirm,
  notification,
} from "antd";
import Orders from "../../components/orders";
import Localize from "../../utils/string";
import { CloseIcon, Cross, RightArrow, SuccessCheck } from "../../assets/images";
import QuantityCounter from "../../components/quantityCounter";
import { useDispatch, useSelector } from "react-redux";
import { ProductsMdl } from "../../Modal/Products";
import {
  CartDetailShow,
  CartInfo,
  DeleteCart,
  ProceedToCheckOut,
} from "../../store/products/productsAsyncActions";
import { setLoading } from "../../store/common/commonActions";
import Loadingtext from "../../components/loading";
import { useHistory } from "react-router-dom";
import {
  storeAddedCartProduct,
  storeCartDetails,
} from "../../store/products/productsActions";

const { TextArea } = Input;
const Cart = () => {
  const Loading = useSelector((state: any) => state.common.loading);

  const AddedCartProduct: any = useSelector(
    (state: any) => state.products.AddedCartProduct
  );
  const loginResp = useSelector((state: any) => state.user.userSession);
  const [loading, setloading] = useState(false);
  const [shippingAddress, setShippingAddress] = useState("");
  const [cartData, setCartData] = useState([] as any);
  const [isMobile, setIsMobile] = useState<boolean>(false);
  const dispatch = useDispatch();
  const history = useHistory();
  const [cartTime, setCartTime] = useState<any>(null);
  const [isSuccess, setIsSuccess] = useState<boolean>(false);
  const [isModal, setIsModal] = useState<boolean>(false);
  const [isEdit, setIsEdit] = useState<boolean>(false);
  const [updateArray, setUpdateArray] = useState<any[]>([]);
  const [buttonText, setButtonText] = useState<string>('Place Order');
  let timer: any; // Declare timer with correct type for Node.js

  useEffect(() => {
    const products = { ...AddedCartProduct };
    products?.cartItems?.forEach((product: any) => {
      product.products.discountPrice = product?.price;
    })
    setCartData(products);
  }, [AddedCartProduct]);


  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 992); // You can adjust the threshold according to your needs
    };

    // Listen to window resize events
    window.addEventListener("resize", handleResize);

    // Call the handler once to set the initial value
    handleResize();

    // Cleanup the event listener
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  async function plusHandler(params: any, isCall?: boolean) {
    if (params?.count >= 0) {
      const quantity = params.count;

      if (isCall) {
        // Find te item index in the existing cartItems array
        const index = AddedCartProduct.cartItems.findIndex(
          (item: any) => item?.id === params?.id
        );

        if (index !== -1) {
          // Directly update the existing object inside AddedCartProduct
          const updatedItem = {
            ...AddedCartProduct.cartItems[index],
            quantity: quantity,
          };

          // Update the cartItems array at the given index
          const updatedCartItems = [...AddedCartProduct.cartItems];
          updatedCartItems[index] = updatedItem;

          // Update the state with the modified cartItems
          AddedCartProduct.cartItems = updatedCartItems;

          // Update the totalAmount after changing the quantity (optional)
          AddedCartProduct.totalAmount = AddedCartProduct.cartItems.reduce(
            (total: number, item: any) => total + item.quantity * item.price,
            0
          );

          // Now trigger the state update (still using setCartData)
          setCartData({ ...AddedCartProduct }); // Spread operator ensures state update
        }
      } else {
        setloading(true);
        // Clear any existing timer before starting a new one
        clearTimeout(cartTime);
        // Set a new timer to execute the API call after 1 second
        timer = setTimeout(async () => {
          const params1 = {
            id: params?.id,
            quantity: quantity,
          };
          let response: any;
          if (params1?.quantity !== 0) {
            response = await dispatch(CartInfo(params1));
          } else {
            response = await confirm(params1?.id);
          }
          if (response) {
            const Qparams: any = `?customerId=${loginResp?.userId}`;

            // Fetch updated cart details
            const response1: any = await dispatch(CartDetailShow(Qparams));
            if (response1) {
              setLoading(false);
              setloading(false)
              setCartData(response1?.data?.[0]);
              setButtonText("Place Order");
              if (response?.status !== 200) {
                notification["error"]({
                  message: response?.message ?? '',
                  description: "",
                  placement: "bottomRight",
                });
              }
            }
          }
        }, 2000); // Trigger after 1 second of inactivity
        setCartTime(timer)
      }
    }
  }

  async function minusHandler(params: any, id: any) {
    // Ensure count is greater than 1 before decreasing the quantity
    if (params?.count > 1) {
      const quantity = params.count - 1;

      // Find the item index in the existing cartItems array
      const index = AddedCartProduct.cartItems.findIndex(
        (item: any) => item?.id === params?.id
      );

      if (index !== -1) {
        // Directly update the existing object inside AddedCartProduct
        const updatedItem = {
          ...AddedCartProduct.cartItems[index],
          quantity: quantity,
        };

        // Update the cartItems array at the given index
        const updatedCartItems = [...AddedCartProduct.cartItems];
        updatedCartItems[index] = updatedItem;

        // Update the state with the modified cartItems
        AddedCartProduct.cartItems = updatedCartItems;

        // Update the totalAmount after changing the quantity (optional)
        AddedCartProduct.totalAmount = AddedCartProduct.cartItems.reduce(
          (total: number, item: any) => total + item.quantity * item.price,
          0
        );

        // Now trigger the state update (still using setCartData)
        setCartData({ ...AddedCartProduct }); // Spread operator ensures state update
      }

      // Clear any existing timer before starting a new one
      clearTimeout(cartTime);
      // Set a new timer to execute the API call after 1 second
      timer = setTimeout(async () => {
        const params1 = {
          id: params?.id,
          quantity: quantity,
        };

        // Perform the API call to update cart info
        const response: any = await dispatch(CartInfo(params1));
        if (response) {
          const Qparams: any = `?customerId=${loginResp?.userId}`;

          // Fetch updated cart details
          const response1: any = await dispatch(CartDetailShow(Qparams));
          if (response1) {
            setLoading(false);
            setloading(false);
            setCartData(response1?.data?.[0]);
            if (response?.status !== 200) {
              notification["error"]({
                message: response?.message ?? '',
                description: "",
                placement: "bottomRight",
              });
            }
          }
        }
      }, 400); // Trigger after 1 second of inactivity
      setCartTime(timer)
    }
  }

  useEffect(() => {
    const cartDataFetch = async () => { };
    const fetchData = async () => {
      if (loginResp?.userId) {
        const Qparams: any = `?customerId=${loginResp?.userId}`;
        const response1: any = await dispatch(CartDetailShow(Qparams));
        setCartData(response1?.data?.[0]);
        cartDataFetch();
      }
    };

    fetchData();
    dispatch(setLoading(true));
  }, []);
  useEffect(() => {
    if (!loginResp) {
      history.push("/login");
    }
  }, [loginResp]);

  const handleClick = async (params: string) => {
    dispatch(setLoading(true));
    // setloading(true)
    const param = {
      // cartItemId: AddedCartProduct?.id,
      customerId: loginResp?.userId
      // shippingNotes: params,
    };
    const response: any = await dispatch(ProceedToCheckOut(param));
    if (response) {
      const Qparams: any = `?customerId=${loginResp?.userId}`;
      const response1: any = await dispatch(CartDetailShow(Qparams));
      if (response1) {
        // notification["success"]({
        //   message: 'Order Placed Successfully',
        //   description: "",
        //   placement: "bottomRight",
        // });
        // setloading(false);
        setIsSuccess(true);
        setCartData(response1?.data?.[0]);
        setShippingAddress("");
      } else {
        // setloading(false)
        setIsSuccess(false);
      }
    }
  };

  async function confirm(id: any) {
    const query: any = `?cartItemId=${id}`;
    const response: any = await dispatch(DeleteCart(query));
    if (response) {
      const Qparams: any = `?customerId=${loginResp?.userId}`;
      const response1: any = await dispatch(CartDetailShow(Qparams));
      setCartData(response1?.data?.[0]);
      notification["success"]({
        message: " Product removed from your cart.",
        description: "",
        placement: "bottomRight",
      });
    }
  }

  const handleBack = () => {
    history.goBack();
  }

  const columns = [
    {
      title: "",
      dataIndex: "products",
      key: "products",
      render: (item: any) => {
        return (
          <Image
            src={`${process.env.REACT_APP_IMAGES_URL}products/${item?.productType?.name}/${item?.catNo}/promos/images/rel.jpg`}
          />
        );
      },
    },
    {
      title: "Name",
      dataIndex: "products",
      key: "products",
      render: (text: any) => {
        return text.title;
      },
    },
    {
      title: "Cat No ",
      dataIndex: "products",
      key: "products",
      render: (text: any) => {
        return text.catNo;
      },
    },
    {
      title: "Price",
      dataIndex: "products",
      key: "products",
      render: (text: any) => {
        return `£${text.discountPrice ? text.discountPrice.toFixed(2) : text.sellPrice}`;
      },
    },
    {
      title: "Quantity",
      dataIndex: "quantity",
      key: "quantity",
      render: (text: any, id: any) => {
        return (
          <div className="counter">
            {
              isEdit ? <input value={text || ''} type="text" onChange={(e) => {
                const value = e.target.value;
                const numericValue = +value;
                if (numericValue >= 0 || value === '') {
                  const newItem = { id: id?.id, count: numericValue };
                  setUpdateArray(prev => {
                    const index = prev.findIndex(item => item.id === newItem?.id);
                    if (index !== -1) {
                      prev[index] = { ...prev[index], count: numericValue };
                      return prev;
                    } else {
                      return [...prev, newItem];
                    }
                  });
                  plusHandler({ id: id?.id, count: numericValue }, true)
                }
              }} className="quantity-input" /> : <div className="quantity-input without-input">{text || ''}</div>
            }
          </div>
        );
      },
    },

    {
      title: "",
      dataIndex: "delete",
      key: "delete",
      render: (row: any, id: any) => {
        return (
          <div
            id={`popOverContainer_${id.key}`}
            className="cart-delete-popover"
          >
            <Popconfirm
              placement="left"
              getPopupContainer={(triggerNode: HTMLElement) =>
                document.getElementById(
                  `popOverContainer_${id.key}`
                ) as HTMLElement
              }
              title="Are you sure you want to remove this from your order?"
              onConfirm={() => confirm(id?.id)}
              okText="Remove"
              cancelText="Cancel"
            >
              <span className="delete-icon">
                <Cross />
              </span>
            </Popconfirm>
          </div>
        );
      },
    },
  ];
  const setAddress = (props: any) => {
    setShippingAddress(props.target.value);
  };

  if (isSuccess) {
    return (
      <div className="succes-wrapper">
        {/* <SuccessCheck /> */}
        <h2>
          Order Placed Successfully!
        </h2>
        <p>Your order has been sent to your sales rep, you should also receive confirmation of this via email. The sales rep will notify you once it’s been processed.</p>
        <p>Thanks for shopping with Prime Direct Distribution.</p>
      </div>
    )
  }

  return Loading ? (
    <Loadingtext />
  ) : (

    <>
      {
        isMobile ? (
          <div className="cart-mobile-wrapper">
            <div className="cart-header">

              <div onClick={handleBack} className="cart-back-arrow">
                <RightArrow />
              </div>
              <h3>
                Cart
              </h3>
            </div>

            <div className={`cart-card-wrapper ${cartData?.cartItems && cartData?.cartItems.length > 0 ? '' : 'cart-card-empty'}`}>
              <div className="cart-cards">
                {cartData?.cartItems && cartData?.cartItems.length > 0 ?
                  (
                    cartData?.cartItems.map((option: any, index: number) => (
                      <div className="cart-card" key={index}>
                        <div className="image-wrapper">
                          <img
                            className="cart-image"
                            src={`${process.env.REACT_APP_IMAGES_URL}products/${option?.products?.productType?.name}/${option?.products?.catNo}/promos/images/rel.jpg`}
                          />
                        </div>

                        <div className="card-content">
                          <div className="heading-cross-wrapper">
                            <h2 className="title">
                              {option?.products?.title ?? ''}
                            </h2>
                            {/* <span>
                            <img
                              src={CloseIcon}
                              alt="close-icon"
                              height={"10px"}
                              width={"10px"}
                            />
                          </span> */}
                            <div
                              id={`popOverContainer_${option.key}`}
                              className="cart-delete-popover"
                            >
                              <Popconfirm
                                placement="left"
                                getPopupContainer={(triggerNode: HTMLElement) =>
                                  document.getElementById(
                                    `popOverContainer_${option.key}`
                                  ) as HTMLElement
                                }
                                title="
                              Are you sure you want to remove this cart"
                                onConfirm={() => confirm(option?.id)}
                                okText="Remove"
                                cancelText="Cancel"
                              >
                                <span className="delete-icon">
                                  <Cross />
                                </span>
                              </Popconfirm>
                            </div>
                          </div>
                          <p className="quantity">
                            Quantity: {option?.quantity ?? 0}
                          </p>

                          <div className="quantity-price-wrapper">
                            <p className="price">
                              £{option?.price}<sub className="discount-price">{option?.products?.sellPrice}</sub>
                            </p>
                            <div className="counter">
                              {
                                isEdit ? (
                                  <input value={option?.quantity || ''} type="text" onChange={(e) => {
                                    const value = e.target.value;
                                    const numericValue = +value; // Convert the value to a number

                                    // Only set the count if the numeric value is not negative
                                    if (numericValue >= 0 || value === '') {
                                      // setCount(numericValue);  // Allow empty input as well (e.g., user clears the input)
                                      plusHandler({ id: option?.id, count: numericValue })
                                    }
                                  }} className="quantity-input" />
                                ) : (
                                  <div className="quantity-input without-input">{option?.quantity}</div>
                                )
                              }
                            </div>
                          </div>
                        </div>
                      </div>
                    ))
                  )

                  : (<div className="no-record-parent">
                    <div className="ant-empty-description">
                      Nothing in cart.
                    </div>
                  </div>)}
              </div>
              {cartData?.cartItems && cartData?.cartItems.length > 0 &&
                <>
                  <Button
                    className="rounded-btn cart-button"
                    shape="circle"
                    onClick={async () => {
                      if (isEdit) {
                        if(updateArray.length > 0){
                          const Qparams: any = `?customerId=${loginResp?.userId}`;
                          const response1: any = await dispatch(CartDetailShow(Qparams));
                        }
                        setIsEdit(false)
                      } else {
                        setIsEdit(true)
                      }
                    }}
                  >
                    {isEdit ? 'Undo' : 'Edit'}
                  </Button>
                  <Button
                    className="rounded-btn cart-button"
                    shape="circle"
                    onClick={() => {
                      if (isEdit) {
                        if (updateArray && updateArray.length > 0) {
                          Promise.all(updateArray.map(option => plusHandler(option)))
                            .then(() => {
                              setIsEdit(false);
                              setUpdateArray([]);
                            })
                        }
                      } else {
                        // Check if any product has quantity 0
                        const hasZeroQuantity = AddedCartProduct.cartItems.some((option: any) => option?.quantity === 0);
                        if (hasZeroQuantity) {
                          notification["error"]({
                            message: "You must add a quantity for all items in your cart before proceeding. Please update the quantities.",
                            description: "",
                            placement: "bottomRight",
                          });
                          return;  // Exit early if there's a product with quantity 0
                        }
                        setIsModal(true)
                      }
                    }}
                    loading={loading}
                  >
                    {isEdit ? "Save Changes" : buttonText}
                  </Button>
                </>
              }
            </div>
          </div>
        ) : (
          <div className="cart-page">
            <div className="cart-page-inner">
              <Typography.Title level={2}>{Localize.CartHeading}</Typography.Title>
              {
                cartData?.cartItems ? (<div className="cartitems-data">
                  <Orders dataSource={cartData?.cartItems} columns={columns} />
                </div>) : (<div className="cart-empty ant-empty-description">
                  Nothing in cart.
                </div>)
              }
              <Row>
                <Col xs={24} sm={13} lg={13} xl={13}>
                  {/* <div className="ant-form-item shipping-address">
                <div className="ant-form-item-label">
                  <label title="Email">Shipping Notes</label>
                </div>
                <div className="ant-form-item-control">
                  <div className="ant-form-item-control-input">
                    <div className="ant-form-item-control-input-content">
                      <TextArea
                        style={{ height: 120 }}
                        onChange={(value: any) => setAddress(value)}
                        value={shippingAddress}
                      />
                    </div>
                  </div>
                </div>
              </div> */}
                </Col>
                <Col xs={23} sm={10} lg={10} xl={10} offset={1}>
                  {
                    cartData && cartData?.cartItems && cartData?.cartItems?.length > 0 && (
                      <div className="cart-page-bottom">
                        <div className="cart-page-bottom2">
                          <div className="columns"></div>

                          <div className="columns total">
                            <Typography.Title level={5}>Total</Typography.Title>
                            <Typography.Title level={5}>
                              £
                              {AddedCartProduct?.totalAmount
                                ? Number(AddedCartProduct?.totalAmount).toFixed(2)
                                : (0).toFixed(2)}
                            </Typography.Title>
                          </div>
                          <div className="columns">
                            <Button
                              className="rounded-btn cart-button"
                              shape="circle"
                              onClick={async () => {
                                if (isEdit) {
                                  if(updateArray.length > 0){
                                    const Qparams: any = `?customerId=${loginResp?.userId}`;
                                    const response1: any = await dispatch(CartDetailShow(Qparams));
                                  }
                                  setIsEdit(false)
                                } else {
                                  setIsEdit(true)
                                }
                              }}
                            >
                              {isEdit ? 'Undo' : 'Edit'}
                            </Button>
                            <Button
                              className="rounded-btn cart-button"
                              shape="circle"
                              onClick={() => {
                                if (isEdit) {
                                  if (updateArray && updateArray.length > 0) {
                                    Promise.all(updateArray.map(option => plusHandler(option)))
                                      .then(() => {
                                        setIsEdit(false);
                                        setUpdateArray([]);
                                      })
                                  }
                                } else {
                                  // Check if any product has quantity 0
                                  const hasZeroQuantity = AddedCartProduct.cartItems.some((option: any) => option?.quantity === 0);
                                  if (hasZeroQuantity) {
                                    notification["error"]({
                                      message: "You must add a quantity for all items in your cart before proceeding. Please update the quantities.",
                                      description: "",
                                      placement: "bottomRight",
                                    });
                                    return;  // Exit early if there's a product with quantity 0
                                  }
                                  setIsModal(true)
                                }
                              }}
                              loading={loading}
                            >
                              {isEdit ? "Save Changes" : buttonText}
                            </Button>
                          </div>
                        </div>
                      </div>
                    )
                  }
                </Col>
              </Row>
            </div>
          </div>
        )
      }

      {
        isModal && (
          <div className="modal">
            <div className="modal-wrapper">
              <h2 className="modal-heading">Place Order?</h2>
              <p className="modal-description">
                When you place the order, it will be sent to your sales rep. It will be processed and then they will get back to you with the next steps. Would you like to place your order now or go back and amend it before sending?
              </p>
              <div className="button-wrapper">
                <Button
                  className="rounded-btn cart-button"
                  shape="circle"
                  onClick={() => setIsModal(false)}
                  loading={loading}
                >
                  Back
                </Button>
                <Button
                  className="rounded-btn cart-button"
                  shape="circle"
                  onClick={() => handleClick(shippingAddress)}
                  loading={loading}
                >
                  Place Order
                </Button>
              </div>
            </div>
          </div>
        )
      }
    </>

  );
};

export default Cart;
